import { render } from "./RFQ.vue?vue&type=template&id=07de85cc"
import script from "./RFQ.vue?vue&type=script&lang=js"
export * from "./RFQ.vue?vue&type=script&lang=js"
script.render = render

export default script